import React, { useEffect } from 'react';
import { CollectionStateProvider } from 'Context/CollectionStateContext';
import PropTypes from 'prop-types';
import { initializeSegment, teardownSegment } from 'EventTracking/Vendors/Segment';
import { initializeGoogleAnalytics, teardownGoogleAnalytics } from 'EventTracking/Vendors/GoogleAnalytics';
import Container from './Container';

const HasRelationship = ({ relationship }) => {
  useEffect(() => {
    // Register google analytics and segment and register event listeners
    initializeGoogleAnalytics();
    initializeSegment();

    return () => {
      teardownGoogleAnalytics();
      teardownSegment();
    };
  }, []);

  return (
    <CollectionStateProvider
      args={{
        relationship,
      }}
    >
      <Container
        relationship={relationship}
      />
    </CollectionStateProvider>
  );
};

HasRelationship.propTypes = {
  relationship: PropTypes.object.isRequired,
};

export { HasRelationship };
